import MuiTooltip, { TooltipProps } from '@material-ui/core/Tooltip';
import React from 'react';
import styled, { css, Palette, PaletteVariants, Sizes } from 'styled-components';
import { TinkTheme } from '../../providers/ThemeProvider/theme';

export const getTooltipStyles = (theme: TinkTheme) => ({
  fontSize: theme.sizes.normal,
  color: theme.palette.black.main,
  padding: theme.sizes.large,
  borderRadius: theme.sizes.xxxsmall,
  backgroundColor: theme.palette.white.main,
  boxShadow: theme.shadows.giga,
});

export type StyledTooltipProps = TooltipProps & {
  padding?: Sizes;
  fontSize?: Sizes;
  bgColor?: Palette;
  color?: Palette;
  bgColorShade?: PaletteVariants | 'main';
  maxwidth?: string;
};

const StyledMuiTooltip = styled((props) => (
  <MuiTooltip
    classes={{ popper: props.className, tooltip: 'tooltip', arrow: 'arrow' }}
    {...props}
  />
))`
  & .tooltip {
    ${(props) =>
      css`
        padding: ${props.padding ? props.theme.sizes[props.padding] : props.theme.sizes.large};
        font-size: ${props.fontSize ? props.theme.sizes[props.fontSize] : props.theme.sizes.normal};
        background-color: ${props.bgColor
          ? props.theme.palette[props.bgColor][props.bgColorShade]
          : props.theme.palette.white.main};
        color: ${props.color
          ? props.theme.palette[props.color].main
          : props.theme.palette.black.main};
        max-width: ${props.maxwidth};
      `}
  }

  & .arrow {
    ${(props) =>
      css`
        color: ${props.bgColor
          ? props.theme.palette[props.bgColor][props.bgColorShade]
          : props.theme.palette.white.main};
      `}
  }
`;

export const Tooltip: React.FC<StyledTooltipProps> = ({ arrow = true, ...props }) => (
  <StyledMuiTooltip arrow={arrow} {...props} />
);
